module.exports = __webpack_public_path__ + "img/fourday_ps_10.575a3fb2.jpg";